export const SITE_ORIGIN = 'https://reggaewheels-2482a.web.app'

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/og-image.jpg`

export const SITE_NAME = 'Reggae Wheels'

export const DEFAULT_DESCRIPTION =
  'Jamaica tours, airport shuttles, and bus rental from Discovery Bay. Explore Montego Bay, Ocho Rios, and Negril with Reggae Wheels.'
